import React from 'react';

import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {translations} from 'presentation/translations-new';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {InitialStep, ListStep} from './components';
import {useConsultRefund} from '../../hooks';

const {title} = translations['pt-br'].privateFlow.consultRefund;

export function ConsultRefund() {
	const {handleBack, step, handleExitFlow} = useConsultRefund();

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				dataTagId={{
					closeButton: RefundTaggingEnum.CLICK_FECHAR_CONSULTAR_REEMBOLSO,
					backButton: RefundTaggingEnum.CLICK_VOLTAR_CONSULTAR_REEMBOLSO,
				}}
				variant="subRoute"
				title={title}
				handleBack={handleBack}
				handleClose={handleExitFlow}
			/>
			{!step ? <InitialStep variant="refund" /> : <ListStep variant="refund" />}
		</PageWrapperLayout>
	);
}
